import is from 'typescript-styled-is'
import styled, { ITheme } from '../../theme'

const AddButton = styled.div<IAddButton>`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: ${({ size }) => (size ? 24 * size : 24)}px;
  min-width: ${({ size }) => (size ? 24 * size : 24)}px;
  width: ${({ size }) => (size ? 24 * size : 24)}px;
  height: ${({ size }) => (size ? 24 * size : 24)}px;
  border-radius: 3px;
  background-color: ${(props: ITheme & IAddButton) =>
    props.color
      ? props.color
      : props.disabled
      ? props.theme.colors.palette.lightGrey
      : props.theme.colors.palette.emerald};
  color: white;
  cursor: ${(props: ITheme & IAddButton) =>
    props.disabled ? 'not-allowed' : 'pointer'};
  ${is('isDisabled')`
      color: white;
      background-color: ${(props: ITheme) =>
        props.theme.colors.palette.lightGrey};
  `}
`

export default AddButton

export interface IAddButton {
  color?: string
  disabled?: boolean
  isDisabled?: boolean
  size?: number
}
